// Audio
import successShortAudio from '@/assets/sounds/success_short.mp3';
import successLongAudio from '@/assets/sounds/success_long.flac';
import failureScanAudio from '@/assets/sounds/failure_short.flac';
import failureSystemAudio from '@/assets/sounds/failure_long.flac';
import pauseAudio from '@/assets/sounds/smb_pause.flac';

// Constants
import soundNames from '@/constants/soundNames';

const currentlyPlayingSounds = [];
const successShort = new Audio( successShortAudio );
const successLong = new Audio( successLongAudio );
const failureScan = new Audio( failureScanAudio );
const failureSystem = new Audio( failureSystemAudio );
const pause = new Audio( pauseAudio );

successShort.preload = 'auto';
successLong.preload = 'auto';
failureScan.preload = 'auto';
failureSystem.preload = 'auto';
pause.preload = 'auto';

const getSound = ( soundName ) => {
    switch ( soundName ) {
        case soundNames.SUCCESS_SHORT:
            return successShort;
        case soundNames.SUCCESS_LONG:
            return successLong;
        case soundNames.FAILURE_SHORT:
            return failureScan;
        case soundNames.FAILURE_LONG:
            return failureSystem;
        case soundNames.PAUSE:
            return pause;
        default:
            return failureSystem;
    }
};

export { soundNames };

export default {
    playSound: async function playSound( soundName, numberOfPlays ) {
        const sound = getSound( soundName );
        // Recursively play the sound X number of times. Gives a nice Be-Beep effect.
        if ( numberOfPlays > 1 ) {
            setTimeout( async () => {
                await this.playSound( soundName, numberOfPlays - 1 );
            }, 250 );
        }
        // If the sound being requested is in the middle of playing,
        // start it from the beginning
        if ( currentlyPlayingSounds.includes( sound ) ) {
            sound.currentTime = 0;
        } else {
            await sound.play();
            const index = currentlyPlayingSounds.length;
            currentlyPlayingSounds.push( sound );
            sound.addEventListener( 'ended', () => {
                currentlyPlayingSounds.splice( index, 1 );
            } );
        }
    },
};
